export type AudioBridge = Window['electronAPI']['audio'];

export function getAudioBridge(): AudioBridge | null {
  if (typeof window === 'undefined') return null;
  return window.electronAPI?.audio ?? null;
}
